import React from "react";
import DOMPurify from "dompurify";

const HTMLRenderer = ({ htmlContent }) => {
  const sanitizedHTML = DOMPurify.sanitize(htmlContent, {
    FORBID_ATTR: ["style"], // Removes inline styles
  });

  return (
    <div
      style={{
        fontFamily: "Lato, sans-serif",
        lineHeight: "1.6",
        color: "#484848",
      }}
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    ></div>
  );
};

export default HTMLRenderer;
